import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SystemService {

  constructor(private http: HttpClient) { }

  getAllLang() {
    return this.http.get<any>(
      `${environment.API_URL}/api/syslanguages`);
  }

  getSystemParameters() {
    return this.http.get<any>(
      `${environment.API_URL}/api/sysparameters`);
  }

  getModuleParameters() {
    return this.http.get<any>(
      `${environment.API_URL}/api/sysmoduleparameters`);
  }

  getAllCountries() {
    return this.http.get<any>(
      `${environment.API_URL}/api/syscountries`);
  }

  getCountry(id: number) {
    return this.http.get<any>(
      `${environment.API_URL}/api/syscountries/${id}`);
  }


  addCountry(countryNameAr: string, countryNameEn: string) {
    return this.http.post<any>(
      `${environment.API_URL}/api/syscountries`, { countryNameAr, countryNameEn });
  }

  deleteCountry(id: number) {
    return this.http.delete<any>(
      `${environment.API_URL}/api/syscountries/${id}`);
  }

  updateCountry(id: number, countryNameAr: string, countryNameEn: string) {
    return this.http.put<any>(
      `${environment.API_URL}/api/syscountries/${id}`, { id, countryNameAr, countryNameEn });
  }


  getAllRegions() {
    return this.http.get<any>(
      `${environment.API_URL}/api/sysregions`);
  }

  getRegion(id: number) {
    return this.http.get<any>(
      `${environment.API_URL}/api/sysregions/${id}`);
  }


  addRegion(countryid: number, regionNameAr: string, regionNameEn: string) {
    return this.http.post<any>(
      `${environment.API_URL}/api/sysregions`, { countryid, regionNameAr, regionNameEn });
  }

  deleteRegion(id: number) {
    return this.http.delete<any>(
      `${environment.API_URL}/api/sysregions/${id}`);
  }

  updateRegion(id: number, countryid: number, regionNameAr: string, regionNameEn: string) {
    return this.http.put<any>(
      `${environment.API_URL}/api/sysregions/${id}`, { id, countryid, regionNameAr, regionNameEn });
  }

  getRegionsByCountryId(countryId: number) {
    return this.http.get<any>(
      `${environment.API_URL}/api/sysregionsbycountry/${countryId}`);
  }

  getProvincesByCountryIdAndRegionId(cid: number, rid: number) {
    return this.http.get<any>(
      `${environment.API_URL}/api/sysprovincebycountrybyregion/${cid}/${rid}`);
  }

  getCitiesByCountryIdAndRegionIdAndProvinceId(cid: number, rid: number, pid: number) {
    return this.http.get<any>(
      `${environment.API_URL}/api/syscitiesbycountrybyregionbyprovice/${cid}/${rid}/${pid}`);
  }

  getAllProvincies() {
    return this.http.get<any>(
      `${environment.API_URL}/api/sysprovinces`);
  }

  getProvince(id: number) {
    return this.http.get<any>(
      `${environment.API_URL}/api/sysprovinces/${id}`);
  }


  addProvincie(provinceNameAr: string, provinceNameEn: string,  countryid: any, regionid: any) {
    return this.http.post<any>(
      `${environment.API_URL}/api/sysprovinces`, { provinceNameAr, provinceNameEn, countryid, regionid });
  }

  deleteProvincie(id: number) {
    return this.http.delete<any>(
      `${environment.API_URL}/api/sysprovinces/${id}`);
  }

  updateProvincies(id: number, provinceNameAr: string, provinceNameEn: string, countryid: number, regionid: number) {
    return this.http.put<any>(
      `${environment.API_URL}/api/sysprovinces/${id}`, { id, provinceNameAr, provinceNameEn, countryid, regionid });
  }

  //city

  getAllCities() {
    return this.http.get<any>(
      `${environment.API_URL}/api/syscities`);
  }

  getCity(id: number) {
    return this.http.get<any>(
      `${environment.API_URL}/api/syscities/${id}`);
  }


  addCity(cityNameAr: string, cityNameEn: string, countryid: any, regionid: any,provinceid:any) {
    return this.http.post<any>(
      `${environment.API_URL}/api/syscities`, { cityNameAr, cityNameEn, countryid, regionid,provinceid });
  }

  deleteCity(id: number) {
    return this.http.delete<any>(
      `${environment.API_URL}/api/syscities/${id}`);
  }

  updateCity(id: number, cityNameAr: string, cityNameEn: string, countryid: number, regionid: number,provinceid:any) {
    return this.http.put<any>(
      `${environment.API_URL}/api/syscities/${id}`, { id, cityNameAr, cityNameEn, countryid, regionid,provinceid });
  }

  getSystemModuleParamValue(id: number) {
    return this.http.get<any>(
      `${environment.API_URL}/api/sysmoduleparameters/${id}`);
  }

  updateSysModuleParameter(id: number, parameterValue: string, productid: number, moduleid: number, parameterCode: string, editableParameter: string) {
    return this.http.put<any>(
      `${environment.API_URL}/api/sysmoduleparameters/${id}`, { id, parameterValue, productid, moduleid, parameterCode, editableParameter });
  }

  updateSysParameter(id: number, parameterCode: string, parameterValue: string) {
    return this.http.put<any>(
      `${environment.API_URL}/api/sysparameters/${id}`, { id, parameterCode, parameterValue });
  }

  getAcmSemester(semesteId: number) {
    return this.http.get<any>(
      `${environment.API_URL}/api/acmsemester/${semesteId}`);
  }

  getYear(id: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/acmyear/${id}`);
  }
}
